module.exports = __webpack_public_path__ + "static/banner-about-61c6dcb008e1da33051c8877fd57f367.jpg";